'use memo';

import { createFileRoute } from '@tanstack/react-router';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { IssueTypeSelectionPage } from './-components/IssueTypeSelectionPage';

/**
 * 不具合 種別選択画面 (route 登録)。
 *
 * 本体は `-components/IssueTypeSelectionPage.tsx` に分離 (playbook §3.18:
 * AttributeCard + RadioGroup + AccordionButton + ActionButton + Grid 等の
 * heavy generic を route 直下 inline すると cascade)。
 */
export const Route = createFileRoute('/_stacktrace/issues/add-select/')({
  component: IssueAddSelectRouteComponent
});
function IssueAddSelectRouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'issues.addSelect'
  });
  useDocumentTitle(t('pageTitle'));
  return <IssueTypeSelectionPage />;
}